import styled from '@emotion/styled';
import { ModalStyled } from '@nike/nike-design-system-components';
import '@nike/nike-design-tokens/dist/css/tokens.css';

const StyledModal = styled(ModalStyled)`
  .submission-process {
    .modal-header-container {
      width: 100% !important;
      text-align: center;

      .icon-wrapper {
        width: 80px;
        display: block;
        margin: var(--podium-cds-size-spacing-xl) auto
          var(--podium-cds-size-spacing-xxl);
      }

      header {
        padding-right: 0;
      }
    }

    .close-btn-container {
      display: none;
    }
  }

  .warning-alert {
    .close-btn-container {
      display: none;
    }
  }
`;

export default StyledModal;
